import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DiscardChangesComponent } from '../components/discard-changes/discard-changes.component';
import {
  ClientQuestionnaireBase,
} from '../components/base-client-questionnaire/form/base-form/client-questionnaire.base';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';

@Injectable()
export class ClientQuestionnaireEditingGuard implements CanDeactivate<ClientQuestionnaireBase<any>> {
  canDeactivate(component: ClientQuestionnaireBase<any>, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.advancedForm.pristine === true ||
      component.formStatusEnum === ClientQuestionnaireStatusEnum.Finalized) {
      return true;
    }

    return new Observable(subscriber => {
      const modal = component.modalService.open(DiscardChangesComponent);
      modal.closed.subscribe(result => {
        subscriber.next(result);
        subscriber.complete();
      });
    });
  }

}
